import { useState } from "react";

// Ported from frontend_Admin/src/components/common/Avatar.jsx — same
// technique (photo-or-initials, onError falls back to initials so a
// broken/truncated data URL never just sits there blank), restyled to
// this app's neutral-* palette instead of Admin's violet/blue/etc set.
// The two apps are separate CRA projects with no shared component
// folder, so this is a deliberate port of the pattern, not a duplicate
// invention — same `photo` value (a data URL straight off User.photo),
// same fallback behavior.
export default function Avatar({ name, photo, size = "h-8 w-8", textSize = "text-[10px]" }) {
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(photo) && !failed;

  if (showPhoto) {
    return (
      <img
        src={photo}
        alt={name || "User"}
        onError={() => setFailed(true)}
        className={`${size} shrink-0 rounded-full object-cover ring-1 ring-black/5`}
      />
    );
  }

  const initials =
    (name || "?").trim().split(/\s+/).map((w) => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase() || "?";
  const colors = ["bg-neutral-700", "bg-neutral-600", "bg-neutral-800", "bg-neutral-500", "bg-neutral-900"];
  const code = (name || "").trim().charCodeAt(0);
  const color = colors[Number.isNaN(code) ? 0 : code % colors.length];
  return (
    <div className={`${size} ${color} flex shrink-0 items-center justify-center rounded-full ${textSize} font-bold text-white`}>
      {initials}
    </div>
  );
}
